import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Production } from 'app/models/produccion.models';
import { environment } from 'environments/environment';
import { Observable } from 'rxjs';

@Injectable({
  providedIn: 'root',
})
export class ProduccionService {
  constructor(private http: HttpClient) {}

  getProducciones(): Observable<Production | any> {
    return this.http.get(environment.apiUrl + 'production');
  }

  getProduccion(id: number) {
    return this.http.get(environment.apiUrl + 'production/' + id);
  }

  getParametrosProduccion() {
    return this.http.get(environment.apiUrl + 'production/parameters/orders');
  }

  getStockInsumosByReceta(idRecipe: number, quantity: number) {
    return this.http.get(environment.apiUrl + `production/stock-calculation/${idRecipe}?quantity=${quantity}`);
  }

  getLote(date: string) {
    return this.http.get(environment.apiUrl + `production/lote/${date}`);
  }

  updateProduccion(id: number, value: any) {
    return this.http.patch(environment.apiUrl + 'production/' + id, value);
  }

  saveProduccion(value: any) {
    return this.http.post(environment.apiUrl + 'production', value);
  }

  deleteProduccion(id: number) {
    return this.http.delete(environment.apiUrl + 'production/' + id);
  }

  getProduccionStatus() {
    return this.http.get(environment.apiUrl + 'production-status');
  }

  // Método para obtener detalles de una receta específica por ID
  getRecipe(id: number): Observable<any> {
    return this.http.get(`${environment.apiUrl}recipes/${id}`);
  }

  getCifData() {
    return this.http.get(environment.apiUrl + 'cif-data');
  }

  saveCifData(dto: any) {
    return this.http.post(environment.apiUrl + 'cif-data', dto);
  }
}
